module.exports = __webpack_public_path__ + "img/伊里斯.47c3997.png";